/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutoSaveTriggerRequest
 */
export interface AutoSaveTriggerRequest {
    /**
     * The ID of the hotel stay to trigger auto-save for.
     * @type {string}
     * @memberof AutoSaveTriggerRequest
     */
    hotelStayId: string;
}

/**
 * Check if a given object implements the AutoSaveTriggerRequest interface.
 */
export function instanceOfAutoSaveTriggerRequest(value: object): value is AutoSaveTriggerRequest {
    if (!('hotelStayId' in value) || value['hotelStayId'] === undefined) return false;
    return true;
}

export function AutoSaveTriggerRequestFromJSON(json: any): AutoSaveTriggerRequest {
    return AutoSaveTriggerRequestFromJSONTyped(json, false);
}

export function AutoSaveTriggerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoSaveTriggerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelStayId': json['hotel_stay_id'],
    };
}

export function AutoSaveTriggerRequestToJSON(json: any): AutoSaveTriggerRequest {
    return AutoSaveTriggerRequestToJSONTyped(json, false);
}

export function AutoSaveTriggerRequestToJSONTyped(value?: AutoSaveTriggerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_stay_id': value['hotelStayId'],
    };
}

